import type { InspirationItem } from '@/app/types';

const getInspirationItemId = (item: InspirationItem) =>
  item.image_asset?.id ?? item.media_asset?.id ?? item.short_film?.id ?? item.tutorial?.id ?? item.mini_video?.id ?? '';

export const mergeInspirationPage = (currentList: InspirationItem[], pageList: InspirationItem[], page: number) => {
  const nextList = page === 1 ? pageList : currentList.concat(pageList);
  const seen = new Set<string>();
  return nextList.filter((item) => {
    const id = getInspirationItemId(item);
    if (!id || seen.has(id)) return false;
    seen.add(id);
    return true;
  });
};
